import 'waypoints/lib/jquery.waypoints.min.js';

/*
 *
 * ----------------------------------------------- */
// jQuery(function ($) {
//   var waypoints = $('#section-concept').waypoint({
//     handler: function (direction) {
//       $(this.element).addClass('active');
//
//       this.destroy();
//     },
//     offset: '25%'
//   });
// });
